import { useEffect, type ReactNode } from 'react';

import type { HeaderSlotName } from './types';
import { useHeaderFilters } from './use-header-filters';

/**
 * Injects page-owned content into a named region of the header for the current
 * route. Same registration idiom as `setFilterConfig` — pass a memoized node,
 * otherwise the effect re-registers on every render.
 *
 * Registrations are scoped to the route they were made on, so leaving the page
 * removes the content from the header without an explicit cleanup.
 */
export const useHeaderSlot = (name: HeaderSlotName, node: ReactNode) => {
  const { setHeaderSlot } = useHeaderFilters();

  useEffect(() => {
    setHeaderSlot(name, node);
  }, [name, node, setHeaderSlot]);
};
